<template>
  <button @click="toggle">
    <slot />
  </button>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    toggle () {
      this.$el.parentElement.classList.toggle('mobile-closed')
      document.body.classList.toggle('overflow-hidden')
    },
  },
}
</script>
